var map = {
	"./app-store-reviews.svg": 22160,
	"./app-store.svg": 71540,
	"./articles.svg": 85394,
	"./custom-inboxes.svg": 11077,
	"./default.svg": 53394,
	"./discord-black.svg": 339,
	"./discord-white.svg": 281,
	"./discord.svg": 19717,
	"./discourse.svg": 72534,
	"./etoro-verified.svg": 53063,
	"./etoro.svg": 85262,
	"./fb-black.svg": 17421,
	"./fb-white.svg": 74579,
	"./fb.svg": 84851,
	"./fm-korea.svg": 73097,
	"./google-play-post-black.svg": 91074,
	"./google-play-post-reviews.svg": 8188,
	"./google-play-post-white.svg": 79944,
	"./google-play-post.svg": 65192,
	"./google-play.svg": 92573,
	"./helpshift.svg": 6,
	"./ig-black.svg": 70117,
	"./ig-white.svg": 80139,
	"./ig.svg": 92699,
	"./intercom-black.svg": 84012,
	"./intercom-white.svg": 46506,
	"./intercom.svg": 91006,
	"./labels.svg": 19134,
	"./linkedin-black.svg": 91379,
	"./linkedin-white.svg": 91321,
	"./linkedin.svg": 89541,
	"./placeholder-network.svg": 51607,
	"./reddit.svg": 93735,
	"./reviews-forums.svg": 17457,
	"./steam-reviews.svg": 94105,
	"./steam.svg": 12425,
	"./tiktok.svg": 70121,
	"./tp.svg": 38875,
	"./trustpilot-black.svg": 14189,
	"./trustpilot-reviews.svg": 98659,
	"./trustpilot-white.svg": 88147,
	"./trustpilot.svg": 54323,
	"./twitter-black.svg": 51238,
	"./twitter-white.svg": 492,
	"./twitter.svg": 99836,
	"./vanilla-black.svg": 52530,
	"./vanilla-white.svg": 29976,
	"./vanilla.svg": 87288,
	"./video-small.svg": 44150,
	"./video.png": 89650,
	"./video.svg": 21268,
	"./weibo.svg": 63633,
	"./wix-answers-post.svg": 79194,
	"./wix-answers.svg": 87147,
	"./xhs.svg": 65454,
	"./yt-black.svg": 17186,
	"./yt-white.svg": 14568,
	"./yt.svg": 9288,
	"./zendesk-black.svg": 84591,
	"./zendesk-white.svg": 12613,
	"./zendesk.svg": 58289
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99993;